export default {
  id: 41,
  title: 'Target #41 - Fox Head',
  url: 'https://cssbattle.dev/play/41',
  colors: ['#293462', '#FE5F55'],
  solution:
    '<a a><a b><a c><style>body{background:#293462}a{position:fixed}a[a],a[b]{top:180;width:50;height:200;box-shadow:0 -100px #FE5F55}a[a]{left:150;border-radius:0 40px 0 0}a[b]{left:200;border-radius:40px 0 0 0}a[c]{top:140;left:165;background:#293462;width:30;height:30;border-radius:50%;box-shadow:40px 0 #293462}</style>',
}
